import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useDepartment, { DepartmentType } from "@/composables/use-department";
import useMostSuggestedRequest from "@/composables/use-most-suggested-request";
import useSearch from "@/composables/use-search";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleItem',
  props: {
    departmentType: {}
  },
  setup(__props: any) {

const props = __props;



const { department } = useDepartment();
const { loadSuggestions } = useMostSuggestedRequest();
const { setUpRequest, focusSearch } = useSearch();

const setDepartmentSearch = (): void => {
	department.value = props.departmentType;
	loadSuggestions();
	setUpRequest();
	focusSearch();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["flex items-center border-b-2 px-4 hover:border-b-current hover:text-black-primary", [_unref(department) === _ctx.departmentType ? 'text-black-primary' : 'border-b-transparent']]),
    onClick: setDepartmentSearch
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})